export const buildSubcategoryListParams = (rawParams = {}) => {
	const params = {};

	Object.keys(rawParams)
		.filter(key => rawParams[key] !== '' && key !== 'page')
		.forEach(key => {
			params[key] = rawParams[key];
		});

	if (params.sort_by) {
		const lastUnderscore = params.sort_by.lastIndexOf('_');
		if (lastUnderscore > 0) {
			params.sort_order = params.sort_by.slice(lastUnderscore + 1);
			params.sort_by = params.sort_by.slice(0, lastUnderscore);
		}
	} else {
		params.sort_by = 'updated_at';
		params.sort_order = 'desc';
	}

	return params;
};

export const getSubcategoryListItems = (list = {}) => {
	if (Array.isArray(list.data)) {
		return list.data;
	}
	return [];
};
